import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.promise.js";
import { getEnvelopeEndpointWithUrlEncodedAuth } from '../api.js';
import { dsnFromString } from '../utils-hoist/dsn.js';
import { createEnvelope, forEachEnvelopeItem } from '../utils-hoist/envelope.js';

/**
 * Gets an event from an envelope.
 *
 * This is only exported for use in the tests
 */
function eventFromEnvelope(env, types) {
  var event;
  forEachEnvelopeItem(env, function (item, type) {
    if (types.includes(type)) {
      event = Array.isArray(item) ? item[1] : undefined;
    }
    // bail out if we found an event
    return !!event;
  });
  return event;
}

/**
 * Creates a transport that overrides the release on all events.
 */
function makeOverrideReleaseTransport(createTransport, release) {
  return function (options) {
    var transport = createTransport(options);
    return _objectSpread(_objectSpread({}, transport), {}, {
      send: function () {
        var _send = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(envelope) {
          var event;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                event = eventFromEnvelope(envelope, ['event', 'transaction', 'profile', 'replay_event']);
                if (event) {
                  event.release = release;
                }
                return _context.abrupt("return", transport.send(envelope));
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function send(_x) {
          return _send.apply(this, arguments);
        }
        return send;
      }()
    });
  };
}

/** Overrides the DSN in the envelope header  */
function overrideDsn(envelope, dsn) {
  return createEnvelope(dsn ? _objectSpread(_objectSpread({}, envelope[0]), {}, {
    dsn: dsn
  }) : envelope[0], envelope[1]);
}

/**
 * Creates a transport that can send events to different DSNs depending on the envelope contents.
 */
function makeMultiplexedTransport(createTransport, matcher) {
  return function (options) {
    var fallbackTransport = createTransport(options);
    var otherTransports = new Map();
    function getTransport(dsn, release) {
      // We create a transport for every unique dsn/release combination as there may be code from multiple releases in
      // use at the same time
      var key = release ? "".concat(dsn, ":").concat(release) : dsn;
      var transport = otherTransports.get(key);
      if (!transport) {
        var validatedDsn = dsnFromString(dsn);
        if (!validatedDsn) {
          return undefined;
        }
        var url = getEnvelopeEndpointWithUrlEncodedAuth(validatedDsn, options.tunnel);
        transport = release ? makeOverrideReleaseTransport(createTransport, release)(_objectSpread(_objectSpread({}, options), {}, {
          url: url
        })) : createTransport(_objectSpread(_objectSpread({}, options), {}, {
          url: url
        }));
        otherTransports.set(key, transport);
      }
      return [dsn, transport];
    }
    function send(_x2) {
      return _send2.apply(this, arguments);
    }
    function _send2() {
      _send2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(envelope) {
        var getEvent, transports, transportsWithFallback, results;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              getEvent = function _getEvent(types) {
                var eventTypes = types && types.length ? types : ['event'];
                return eventFromEnvelope(envelope, eventTypes);
              };
              transports = matcher({
                envelope: envelope,
                getEvent: getEvent
              }).map(function (result) {
                if (typeof result === 'string') {
                  return getTransport(result, undefined);
                } else {
                  return getTransport(result.dsn, result.release);
                }
              }).filter(function (t) {
                return !!t;
              }); // If we have no transports to send to, use the fallback transport
              // Don't override the DSN in the header for the fallback transport. '' is falsy
              transportsWithFallback = transports.length ? transports : [['', fallbackTransport]];
              _context2.next = 5;
              return Promise.all(transportsWithFallback.map(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                  dsn = _ref2[0],
                  transport = _ref2[1];
                return transport.send(overrideDsn(envelope, dsn));
              }));
            case 5:
              results = _context2.sent;
              return _context2.abrupt("return", results[0]);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _send2.apply(this, arguments);
    }
    function flush(_x3) {
      return _flush.apply(this, arguments);
    }
    function _flush() {
      _flush = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(timeout) {
        var allTransports, results;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              allTransports = [].concat(_toConsumableArray(otherTransports.values()), [fallbackTransport]);
              _context3.next = 3;
              return Promise.all(allTransports.map(function (transport) {
                return transport.flush(timeout);
              }));
            case 3:
              results = _context3.sent;
              return _context3.abrupt("return", results.every(function (r) {
                return r;
              }));
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _flush.apply(this, arguments);
    }
    return {
      send: send,
      flush: flush
    };
  };
}
export { eventFromEnvelope, makeMultiplexedTransport };